<template>
	<div>
		<CoolLightBox :items="registrationimages" :index="index" @close="index = null"></CoolLightBox>
		<RentalCarSearchbar ref="rentalCarSearch" @search="search" @directSearch="directSearch" :show-col="showCol" class="mb-8"></RentalCarSearchbar>
		<div class="flex flex-col" v-if="rentalCars">
			<div class="flex justify-between align-middle mb-4">
				<PaginationNumberOfPages :current-page="current_page" :last-page="last_page" :total="total" class="mr-4 self-center" />
				<div class="flex">
					<PaginationSizeSelect v-model="per_page" class="w-40" v-show="rentalCars && rentalCars.length" />
					<BasePagination v-model="current_page" :last-page="last_page" :total="total" :is-blocked="blockSearch" />
				</div>
			</div>
			<div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
				<div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
					<div class="overflow-hidden border-b border-gray-200">
						<table class="min-w-full divide-y divide-gray-200">
							<thead>
								<tr>
									<OverviewTableHeader
										:current-sort="currentSortField === 'company'"
										:current-sort-dir="currentSortDirection"
										:label="$t('company').toString()"
										@click.native="sortby('company')"
										v-if="showCol([1, 2])"
										class="w-2/10"
									/>
									<OverviewTableHeader
										:current-sort="currentSortField === 'license_plate'"
										:current-sort-dir="currentSortDirection"
										:label="$t('license_plate').toString()"
										@click.native="sortby('license_plate')"
										class="w-2/10"
									/>
									<OverviewTableHeader
										:current-sort="currentSortField === 'manufacturer'"
										:current-sort-dir="currentSortDirection"
										:label="$t('vehicle').toString()"
										class="w-2/10"
										@click.native="sortby('manufacturer')"
									/>
									<OverviewTableHeader
										:current-sort="currentSortField === 'rental_car_class'"
										:current-sort-dir="currentSortDirection"
										@click.native="sortby('rental_car_class')"
										:label="$t('class').toString()"
										class="w-1/10 text-center"
									/>
									<OverviewTableHeader :label="$t('currently_rented').toString()" class="w-2/10" />
								</tr>
							</thead>
							<tbody class="bg-white divide-y divide-gray-200">
								<tr
									class="hover:bg-gray-300"
									:class="{ 'cursor-pointer': isUserAllowedInLevel1 }"
									v-for="car in rentalCars"
									:key="car.vehicle.id"
									@click="isUserAllowedInLevel1 && $router.push({ name: 'RentalCarEdit', params: { vehicleId: car.vehicle.id } })"
								>
									<td class="px-6 py-1 text-left w-2/10" :class="{ 'text-red-500': !car.vehicle.rentalCarClass }" v-if="showCol([1, 2])">
										{{ car.company.name.name }}
									</td>
									<td class="px-6 py-1 text-left w-2/10" :class="{ 'text-red-500': !car.vehicle.rentalCarClass }">
										{{ car.vehicle.licensePlate.text }}
									</td>
									<td class="px-6 py-1 text-left w-2/10" :class="{ 'text-red-500': !car.vehicle.rentalCarClass }">
										<div>
											{{ car.vehicle.manufacturer }}
										</div>
										<div>{{ car.vehicle.model }}</div>
									</td>
									<td class="px-6 py-1 text-center w-1/10" :class="{ 'text-red-500': !car.vehicle.rentalCarClass }" v-if="car.vehicle.rentalCarClass">
										{{ car.vehicle.rentalCarClass }}
									</td>

									<td
										class="px-6 py-1 text-center w-1/10"
										:class="{ 'text-red-500': !car.vehicle.rentalCarClass }"
										v-if="!car.vehicle.rentalCarClass"
									>
										<font-awesome-icon
											:icon="['fas', 'question']"
											class="cursor-pointer"
											size="xs"
											:title="$t('classification_pending').toString()"
										/>
									</td>

									<td class="w-2/10">
										<div class="px-6 py-1" :class="{ 'text-red-500': !car.vehicle.rentalCarClass }">
											<router-link v-if="car.damageCase" :to="{ name: 'damagecases.edit', params: { id: car.damageCase.id } }">
												{{
													car.damageCase.customer.gender === 'company'
														? car.damageCase.customer.companyName
														: car.damageCase.customer.firstName + ' ' + car.damageCase.customer.lastName
												}}
												/ {{ car.damageCase.imdNetId }}
											</router-link>
											<div v-else>-</div>
										</div>
									</td>

									<td class="py-1 text-left">
										<div class="cursor-pointer" @click.stop="showRegistrationImage(car.vehicle)" v-if="car.vehicle.registrationImage">
											<font-awesome-icon :icon="['fa', 'id-card']" :title="$t('show_vehicle_registration').toString()"></font-awesome-icon>
										</div>
									</td>
									<td class="py-1 text-left" v-if="getAuthenticatedUserGroupLevel === '1'">
										<font-awesome-icon :icon="['fa', 'edit']" :title="$t('edit_rental_car').toString()"></font-awesome-icon>
									</td>
									<td class="py-1 text-left">
										<div
											v-if="
												getAuthenticatedUserGroupLevel === '1' || getAuthenticatedUserGroupLevel === '5' || getAuthenticatedUserGroupLevel === '6'
											"
										>
											<Toggle :active="car.vehicle.isEnabled" @click.native.prevent="removeCar(car)" />
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<div class="flex justify-between align-middle mb-4 mt-10" v-show="rentalCars && rentalCars.length">
				<PaginationNumberOfPages :current-page="current_page" :last-page="last_page" :total="total" class="mr-4 self-center" />
				<div class="flex">
					<PaginationSizeSelect v-model="per_page" class="w-40" v-show="rentalCars && rentalCars.length" />
					<BasePagination v-model="current_page" :last-page="last_page" :total="total" :is-blocked="blockSearch" />
				</div>
			</div>
		</div>
		<LoadingSpinner v-else />
	</div>
</template>

<script>
import OverviewTableHeader from '@/views/damagecases/OverviewTableHeader';
import RentalCarSearchbar from '@/components/rentalcars/RentalCarSearchbar';
import { VehicleApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import Authentication from '@/mixins/Authentication';
import PaginationSizeSelect from '@/components/damagecases/forms/PaginationSizeSelect';
import PaginationNumberOfPages from '@/components/forms/buttons/PaginationNumberOfPages';
import BasePagination from '@/components/forms/buttons/BasePagination.vue';
import rentalCarForm from '@/components/rentalcars/forms/RentalCarForm.vue';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import Toggle from '@/components/forms/Toggle.vue';

export default {
	name: 'RentalCarList',
	components: { Toggle, LoadingSpinner, BasePagination, RentalCarSearchbar, OverviewTableHeader, PaginationNumberOfPages, PaginationSizeSelect },
	mixins: [Authentication],
	data() {
		return {
			rentalCars: null,
			searchQuery: undefined,
			per_page: { display: '25', value: 25 },
			currentSortField: 'license_plate',
			currentSortDirection: 'asc',
			current_page: 1,
			last_page: 1,
			total: 0,
			blockSearch: false,
			blockPageReset: false,
			registrationimages: [],
			index: null,
		};
	},
	mounted() {
		this.$refs['rentalCarSearch'].directSearch();
	},
	computed: {
		getAuthenticatedUserGroupLevel() {
			return this.$store.getters.getAuthenticatedUserGroupLevel;
		},
	},
	watch: {
		current_page: function(oldValue, newValue) {
			if (oldValue !== newValue) {
				this.blockPageReset = true;
				this.$refs['rentalCarSearch'].directSearch();
			}
		},
		per_page: function() {
			this.$refs['rentalCarSearch'].directSearch();
		},
	},
	methods: {
		showRegistrationImage: function(vehicle) {
			if (!vehicle.registrationImage) {
				this.$swal(this.$t('general.attention').toString(), this.$t('no_vehicle_registration').toString(), 'warning');
			} else {
				this.registrationimages = [vehicle.registrationImage];
				this.index = 0;
			}
		},
		showCol: function(showLvl) {
			return showLvl.indexOf(parseInt(this.$store.getters.getAuthenticatedUserGroupLevel)) !== -1;
		},
		sortby: function(field) {
			if (field === this.currentSortField) {
				this.currentSortDirection = this.currentSortDirection === 'asc' ? 'desc' : 'asc';
			} else {
				this.currentSortDirection = 'asc';
			}
			this.currentSortField = field;
			this.$refs['rentalCarSearch'].directSearch();
		},
		search($event) {
			clearTimeout(this.timeoutIndex);
			this.timeoutIndex = setTimeout(() => {
				this.directSearch($event);
			}, 300);
		},
		directSearch($event) {
			if (this.blockSearch) {
				return;
			}
			if (!this.blockPageReset) {
				this.current_page = 1;
			}

			this.blockSearch = true;
			const sort = (this.currentSortDirection === 'desc' ? '-' : '') + this.currentSortField;

			VehicleApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.rentalcarsGet(
					this.current_page,
					this.per_page ? this.per_page.value : undefined,
					sort,
					$event.company ? $event.company : undefined,
					$event.license_plate ? $event.license_plate : undefined,
					$event.model ? $event.model : undefined,
					$event.manufacturer ? $event.manufacturer : undefined,
					$event.filter ? $event.filter.value : undefined,
				)
				.then(response => {
					this.rentalCars = response.data.data;
					this.current_page = parseInt(response.data.meta.current_page);
					this.last_page = response.data.meta.last_page;
					this.total = response.data.meta.total;
					this.blockSearch = false;
					this.blockPageReset = false;
				})
				.catch(error => {});
		},
		getRentalCars() {
			VehicleApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.rentalcarsGet()
				.then(result => {
					this.rentalCars = result.data;
				})
				.catch(error => {
					this.$swal(this.$t('general.error').toString(), this.$t('rental_car_contract_error').toString(), 'error');
				});
		},
		removeCar(car) {
			if (car.damageCase != null) {
				this.$swal(this.$t('general.hint').toString(), this.$t('remove_rental_car_damage_case').toString(), 'warning');
			} else {
				this.$swal({
					title: this.$t('sure').toString(),
					text: car.vehicle.isEnabled ? this.$t('remove_rental_car').toString() : this.$t('reactivate_rental_car').toString(),
					icon: 'warning',
					cancelButtonText: this.$t('general.cancel'),
					showCancelButton: true,
				}).then(result => {
					if (result.value) {
						VehicleApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
							.rentalcarsIdDelete(car.vehicle.id)
							.then(result => {
								if (car.vehicle.isEnabled) {
									this.$swal(this.$t('general.success').toString(), this.$t('remove_rental_car_success').toString(), 'success');
								} else {
									this.$swal(this.$t('general.success').toString(), this.$t('remove_rental_car_activated_success').toString(), 'success');
								}
								this.$refs.rentalCarSearch.search();
							})
							.catch(error => {
								this.$swal(this.$t('general.error').toString(), this.$t('remove_rental_car_error').toString(), 'error');
							});
					}
				});
			}
		},
	},
};
</script>

<style scoped></style>
